import { Checkbox, FormControlLabel, Grid, List, ListItem, Typography } from "@mui/material"
import { allRoles } from "generated/roles"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { IRole, IRoleTemplate, IRoleTemplates } from "./roleTemplates.interface"

const RoleTemplates = (props: IRoleTemplates) => {
  const { selectedTemplateIds, setFieldValue, userRoleTemplates, setRetriggerValidationObj } = props
  const [selectedIds, setSelectedIds] = useState(selectedTemplateIds)
  const { t } = useTranslation("translation", { keyPrefix: "settings" })

  useEffect(() => {
    setFieldValue("UserRoleTemplateIds", selectedIds)
  }, [selectedIds, setFieldValue])

  const onChange = (id: number, checked: boolean) => {
    setSelectedIds((prev) => (checked ? [...prev, id] : prev.filter((x) => x !== id)))
  }

  useEffect(() => {
    const violationActive = userRoleTemplates
      .filter(template => selectedIds.includes(template.id))
      .some((x) => x.roles.some((y) => y.role === allRoles.Violation))
    const planningActive = userRoleTemplates
      .filter(template => selectedIds.includes(template.id))
      .some((x) => x.roles.some((y) => y.role === allRoles.Planning))
    setRetriggerValidationObj((prevState: any) => ({
      ...prevState,
      violationActive: violationActive,
      planningActive: planningActive
    }))
  }, [selectedIds])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} display="flex" alignItems="center">
        <List>
          {userRoleTemplates.map((value: IRoleTemplate) => {
            return (
              <ListItem disablePadding>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(e) => {
                        onChange(value.id, e.currentTarget.checked)
                      }}
                      id="UserRoleTemplateIds"
                      value={value.id}
                      checked={selectedIds.some((x) => x === value.id)}
                    />
                  }
                  label={value.name}
                />
                <Typography variant="bodySmall" color="textSecondary" style={{ marginLeft: "32px" }}>
                  {value.roles
                    .map((x: IRole) => t("user.modules." + x.translateId, x.translateId))
                    .join(", ")}
                </Typography>
              </ListItem>
            )
          })}
        </List>
      </Grid>
    </Grid>
  )
}

export default RoleTemplates
